import { render, staticRenderFns } from "./BulkDeleteList.vue?vue&type=template&id=182d0238&scoped=true"
import script from "./BulkDeleteList.vue?vue&type=script&lang=js"
export * from "./BulkDeleteList.vue?vue&type=script&lang=js"
import style0 from "./BulkDeleteList.vue?vue&type=style&index=0&id=182d0238&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "182d0238",
  null
  
)

export default component.exports